import React from 'react';

import MessageGroupPage from '../components/PaymentsPage';

const MessageGroupContainer = () => {
  return <MessageGroupPage />;
};

export default MessageGroupContainer;
